import script from "./Serp.vue?vue&type=script&setup=true&lang=js"
export * from "./Serp.vue?vue&type=script&setup=true&lang=js"

import "./Serp.vue?vue&type=style&index=0&id=d29e0d06&lang=scss"

const __exports__ = script;

export default __exports__